import style from './index.module.css'

export default function Header ({ selectedHeader, setSelectedHeader }) {
  const handlePartnerHeader = () => {
    setSelectedHeader('PartnerHeader')
  }
  const handleDonationHeader = () => {
    setSelectedHeader('DonationHeader')
  }
  return (
    <header className={style.header_container_class}>
      <div className={style.text_header_title_style}>
        <div className={style.title_text_header_style} onClick={handlePartnerHeader}>
          <h2 className={style.h2}>Hazte Socio</h2>
        </div>
        <div className={style.title_text_header_style} onClick={handleDonationHeader}>
          <h2 className={style.h2}>Haz una aportación puntual</h2>
        </div>
      </div>
      <div className={style.line_header_title_style}>
        {selectedHeader === 'PartnerHeader' ? <div className={style['linea-activa']} /> : <div className={style.line} />}
        {selectedHeader === 'DonationHeader' ? <div className={style['linea-activa']} /> : <div className={style.line} />}
      </div>
    </header>
  )
}
